import React, { Component } from 'react';
import { Card, Table, Tag } from 'antd';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import moment from 'moment-timezone';

@inject('store')
@withRouter
@observer
export class OrderDetails extends Component {
    render() {
        const timezone = this.props.store.userStore.currentUser.timezone;
        const position = this.props.position;
        if (!position) return null;

        let orders = [];

        (position.buy_orders || []).forEach(order => {
            orders.push({ ...order, side: 'buy' });
        });

        (position.sell_orders || []).forEach(order => {
            orders.push({ ...order, side: 'sell' });
        });

        return (
            <Card title={'Order Details'} bordered={false} size={'small'}>
                <Table
                    size="small"
                    dataSource={orders}
                    rowKey={'id'}
                    columns={[
                        {
                            title: 'Side',
                            dataIndex: 'side',
                            key: 'side',
                            render(text) {
                                return text === 'buy' ? (
                                    <i className="fal fa-arrow-up success" />
                                ) : (
                                    <i className="fal fa-arrow-down error" />
                                );
                            }
                        },
                        {
                            title: 'Date',
                            dataIndex: 'timestamp',
                            key: 'timestamp',
                            render(text) {
                                return moment(text)
                                    .tz(timezone)
                                    .format('DD/MM/YYYY hh:mm:ss a');
                            }
                        },
                        {
                            title: 'Status',
                            dataIndex: 'status',
                            key: 'status',
                            render(text) {
                                return <Tag>{text}</Tag>;
                            }
                        },
                        {
                            title: 'Filled',
                            dataIndex: 'filled',
                            key: 'filled'
                        },
                        {
                            title: 'Avg Price',
                            dataIndex: 'avg_price',
                            key: 'avg_price',
                            render(t, o) {
                                return o.avg_price || o.price || '-';
                            }
                        },
                        {
                            title: 'Fees',
                            dataIndex: 'fees',
                            key: 'fees',
                            render(text) {
                                return text
                                    ? JSON.stringify(text)
                                          .replace(/"/g, '')
                                          .replace(/{/g, '')
                                          .replace(/}/g, '')
                                    : '';
                            }
                        }
                    ]}
                />
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionView/OrderDetails.js